export default {"src":"/_next/static/media/property_records_1.95fb2c2c.gif","height":400,"width":700,"blurWidth":0,"blurHeight":0};